<dx-scroll-view data-testid="default-notification-scroll-view">
<form #formElement (submit)="onSubmit($event)">
<dx-form data-testid="form" id="form" class="cards-wide"
[formData]="notificationData"
[items]="formItems"
[showValidationSummary]="true"
validationGroup="formGroup"
>
  <!-- File Upload Template -->
  <div *dxTemplate="let section of 'fileUploadTemplate'">
    <app-file-upload
      data-testid="default-notification-file-upload"
      labelText=""
      selectButtonText="Browse or drop files here"
      (onFileRemoveEventEmitter)="onFileRemove($event)"
      (onFileUploadEventEmitter)="onFileUpload($event)">
    </app-file-upload>
  </div>
</dx-form>

<dx-load-panel data-testid="default-notification-load-panel"
  container=".cards-wide"
  [position]="{ of: '.content' }"
  [visible]="isLoading"
  [showPane]="true"
></dx-load-panel>
</form>
</dx-scroll-view>
